export interface IAddCreditCardRequest {
    CVV: number;
    CreditCardNumber: string;
    SetAsDefault: boolean;

    MemberID: number;
    ExpMonth: number;
    ExpYear: number;
    FirstName: string;
    LastName: string;
    Address01: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;

}

export class AddCreditCardRequest implements IAddCreditCardRequest {
    CVV: number;
    CreditCardNumber: string;
    SetAsDefault: boolean;
    MemberID: number;
    ExpMonth: number;
    ExpYear: number;
    FirstName: string;
    LastName: string;
    Address01: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;
}
